import { Typography } from '@repo/ui/typography'
import { FC } from 'react'

const TOS_HREF = 'https://aminochain.io/legal#terms-of-use'
const PRIVACY_HREF = 'https://aminochain.io/legal#privacy-policy'

export const TermsFooter: FC<{}> = () => {
  return (
    <Typography size="xs" className="text-center text-grey-500">
      By continuing, you agree to our{' '}
      <a href={TOS_HREF} target="_blank" className="text-mint-600 hover:text-mint-700 underline">
        Terms of Service
      </a>{' '}
      and{' '}
      <a href={PRIVACY_HREF} target="_blank" className="text-mint-600 hover:text-mint-700 underline">
        Privacy Policy
      </a>
      .
    </Typography>
  )
}

// TODO: clean up organization
export const SettingsTermsFooter = () => {
  return (
    <div className="mt-10 space-y-2 text-grey-600">
      <Typography size="sm" className="text-grey-700 font-medium">
        AminoChain Privacy and Terms of Use
      </Typography>
      <Typography size="sm">
        Find more information for{' '}
        <a
          href={TOS_HREF}
          target="_blank"
          className="underline underline-offset-[3px] text-grey-700 hover:text-grey-800"
        >
          Terms of Use
        </a>{' '}
        and{' '}
        <a
          href={PRIVACY_HREF}
          target="_blank"
          className="underline underline-offset-[3px] text-grey-700 hover:text-grey-800"
        >
          Privacy Policy
        </a>
      </Typography>
    </div>
  )
}
